
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { bp: '-200', nii: 371.25 },
  { bp: '-100', nii: 396.00 },
  { bp: '0', nii: 420.75 },
  { bp: '+100', nii: 408.13 },
  { bp: '+200', nii: 395.50 },
  { bp: '+300', nii: 382.88 },
  { bp: '+400', nii: 370.26 },
];

const NIISimChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="bp" label={{ value: 'Rate Change (bps)', position: 'insideBottom', offset: -5 }} />
        <YAxis domain={[350, 450]} label={{ value: 'NII (₹ Cr)', angle: -90, position: 'insideLeft' }} />
        <Tooltip 
          formatter={(value) => [`₹${value} Cr`, 'Net Interest Income']}
          labelFormatter={(label) => `Rate Change: ${label} bps`}
        />
        <Legend />
        <Line 
          type="monotone" 
          dataKey="nii" 
          name="Net Interest Income" 
          stroke="#f59e0b" 
          strokeWidth={2} 
          dot={{ r: 4 }} 
          activeDot={{ r: 6 }} 
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default NIISimChart;
